var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{staticClass:"vframe",attrs:{"id":"upchat_vframe","title":"UpChat","src":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }